import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CreateNew from "../../Components/Button/CreateNew";
import CurrentLatestSeatPlanTable from "../../Components/Tables/CurrentLatestSeatPlanTable";

interface SeatPlanItem {
  id: number;
  ticket_group_code: string;
}

export default function SeatPlan() {
  const [items, setItems] = useState<SeatPlanItem[]>([]);
  const navigate = useNavigate();
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://cdn.pulp.ph/api/v1/pulpliveworld/seatPlan",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        if (isMounted.current) {
          setItems(response.data.seat_plan);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleDelete = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return;
      }

      await axios.delete(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/seatPlan/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Deleted Successfully !!");
      setItems((prevItems) => prevItems.filter((item) => item.id !== id));
    } catch (error) {
      console.error("There was an error deleting the seat plan!", error);
    }
  };

  const handleEdit = (id: number) => {
    navigate(`/update/seat-plan`, { state: { id } });
  };

  return (
    <React.Fragment>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h2 className="mt-5 font-semibold">List of Seat Plan</h2>
          <CreateNew />
        </div>

        <div className="container mt-5">
          <h3 className="font-semibold mb-1">All Seat Plan</h3>
          <CurrentLatestSeatPlanTable
            items={items}
            onDelete={handleDelete}
            onEdit={handleEdit}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
